import { KeycloakService } from 'src/app/angularJS/services/keycloak.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

/**
 * A class that contains methods for manipulating http requests before they are sent
 */
export class RequestInterceptor {
  public static $inject = ['$q', 'keycloakService'];
  public request: Function;

  constructor(private $q: ng.IQService, keycloakService: KeycloakService) {

    /**
     * Function that handles http request objects prior to be sent
     */
    this.request = (config) => {
      const deferred = this.$q.defer();
      const isApiCall = config.url.indexOf('api-') !== -1 || config.url.indexOf('/api') !== -1 || config.url.indexOf('api/') !== -1;

      if (isApiCall) {
        keycloakService.refreshTokenIfRemainingTimeIsLessThan(60).then((refreshed) => {
          config.headers['Authorization'] = 'Bearer ' + keycloakService.getCurrentToken();

          //WHEN RUNNING OUR E2E TESTS WE STILL NEED TO RUN AGAINST A MIDDLEWARE SERVER
          //THE MIDDLEWARE SERVER PERFORMS THIS OPERATION FOR US.
          //ONCE WE UPGRADE TO APIMANAGER VERSION 3. WE WILL NO LONGER NEED TO RUN AGAINST
          //A MIDDLEWARE SERVER AND WE WE UNCOMMENT THIS CODE AND THEN REPOINT OUR CLIENT-SIDE
          //SERVICES TO CONTACT OUR JAVA SERVICES DIRECTLY
          // if (config.method === 'PATCH') {
          //   this.convertBodyToPatchRequests(config);
          // }

          deferred.resolve(config);
        }).catch(() => {
          keycloakService.logout();
          deferred.reject();
        });
      } else {
        deferred.resolve(config);
      }

      return deferred.promise;
    };
  }

  private convertBodyToPatchRequests(config) {
    if (config.url.indexOf('transport-operator-services') === -1 && config.url.indexOf('charge-accounts') === -1) {

      let extractedData = [];
      let i;

      for (i in config.data) {
        if (config.data.hasOwnProperty(i)) {
          extractedData.push({
            'op': 'replace',
            'path': '/' + i,
            'value': _.isString(config.data[i]) || _.isDate(config.data[i]) ? config.data[i] : JSON.stringify(config.data[i])
          });
        }
      }

      config.data = extractedData;
    }
  }
}